import axiosInstance, { ApiKeys, getApiUrl } from '@cp/src/utils/ApiHelper';
import { CASE_DETAILS_TABS_FEATURE_FLAG, STORE_KEYS } from '../constants';
import {
  setCaseDetail,
  setCaseDetailError,
  setCaseDetailLoading,
  setCaseDetailTabsFeatureFlag
} from '../reducers/caseDetailSlice';
import { Dispatch } from '@reduxjs/toolkit';

export const fetchSherlockData =
  (lan: string, customerRefrenceId: string, setLoading: (loading: boolean) => void) =>
  (dispatch: Dispatch) => {
    const url = getApiUrl(ApiKeys.SHERLOCK);
    setLoading(true);
    dispatch(
      setCaseDetailLoading({
        lan,
        customerRefrenceId,
        key: STORE_KEYS.SHERLOCK,
        loading: true
      })
    );
    axiosInstance
      .get(url, { headers: { customerreferenceid: customerRefrenceId, loanaccountnumber: lan } })
      .then(response => {
        dispatch(
          setCaseDetail({
            lan,
            customerRefrenceId,
            key: STORE_KEYS.SHERLOCK,
            data: response.data
          })
        );
        dispatch(
          setCaseDetailTabsFeatureFlag({
            key: CASE_DETAILS_TABS_FEATURE_FLAG.SKIP_TRACING,
            value: !!response.data?.length
          })
        );
      })
      .catch(err => {
        dispatch(
          setCaseDetailError({
            lan,
            customerRefrenceId,
            key: STORE_KEYS.SHERLOCK,
            error: err
          })
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
